import React from 'react'
import './New.css';
// import Name from './images/11.jpg'

const New = () => {
  return (
    <div className='back8'>
      <h1> SPOCC'22</h1>
    {/* <img className="nextp" scr={Name } alt="nextp"/> */}
    <h3>Team CLOUD COMPUTING CELL organized a recruitment drive SPOCC'22 in odd semester 2022-23. In order to continue the trends of the cell for effective learning and capturing intelligent minds to serve the college in even bigger and better way, it is necessary to involve the participation of bright and innovative students and prepare them to achieve the common goal therefore we organized this event. This event includes two rounds. First round consists of aptitude, HTML-CSS, C LANGUAGE and cloud computing based questions whereas second round is personal interview.</h3>
    
  

    </div>
    // <div className="over" style={{background: 'url(${11.jpg})}}
  
      
  
  )
}

export default New ;
